import React from "react";
import HelpText from "../assets/data/helpText.json";
import { Box, Divider, Typography } from "@mui/material";
import Footer from "./Footer";

const Help = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: "95vh",
          width: "100vw",
          marginBottom: "1rem",
        }}
      >
        <Box
          sx={{
            width: "80vw",
            maxWidth: "600px",
            marginTop: "6rem",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.2rem",
              marginBottom: "-0.25rem",
              fontWeight: "900",
            }}
          >
            Help & Support
          </Typography>
          <Divider
            sx={{
              borderColor: "#979797",
              borderWidth: "0.05rem",
              marginY: "1rem",
            }}
          />
          <Typography
            sx={{
                fontSize: "0.875rem",
                lineHeight: "1.5",
                fontWeight: "bold" 
            }}
          >
            Response Lookup 
          </Typography>
          <Box
            sx={{
              marginTop: "2.5rem",
            }}
          >
            {HelpText.data1.map((item, index) => (
              <Box key={index} className="data-item">
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    textDecoration: "underline",
                  }}
                >
                  {item.heading}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  }}
                >
                  {item.paragraph}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              marginTop: "4rem",
            }}
          >
            {HelpText.data2.map((item, index) => (
              <Box key={index} className="data-item">
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    textDecoration: "underline",
                  }}
                >
                  {item.heading}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    marginBottom: "1rem",
                  }}
                >
                  {item.paragraph}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Help;
